import { useCallback } from 'react';
import { useDemoMode, useSession } from '@distribusion/portal-lib/auth';
import { Flex, Text } from '@distribusion/portal-lib/components';
import { Switch } from 'antd';
import { useSetUserDemoMode } from 'features/users/api/users';
import { useTranslation } from 'lib/translation';

import './demo-switch.less';

interface DemoSwitchProps {
  textSize?: 'sm' | 'md' | 'lg';
}

export const DemoSwitch = ({ textSize = 'lg' }: DemoSwitchProps) => {
  const { t } = useTranslation();
  const { data: sessionData } = useSession();
  const { demoModeEnabled } = useDemoMode();
  const { mutateAsync: setDemoMode, ...setDemoModeMutation } = useSetUserDemoMode();

  const handleDemoModeSwitch = useCallback(
    async (checked: boolean) => {
      await setDemoMode({
        id: sessionData?.identity?.id,
        demo_mode: checked,
      });

      window.location.reload();
    },
    [sessionData, setDemoMode],
  );

  return (
    <Flex className="demo-switch" gap="middle" align="center">
      <Text size={textSize}>{t('profile_menu_items.demo_mode')}</Text>
      <Switch
        size="small"
        checked={demoModeEnabled}
        disabled={setDemoModeMutation.isLoading}
        loading={setDemoModeMutation.isLoading}
        onChange={handleDemoModeSwitch}
      />
    </Flex>
  );
};
